import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'dges-logo',
  imports: [],
  templateUrl: './logo.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { style: 'display: block' },
})
export class LogoComponent {
  readonly prefix = input<string>('');
  readonly accent = input<string>('');
  readonly suffix = input<string>('');
  readonly minimal = input<boolean>(false);
}
